{
  "list": {
    "title": "My hosting requests",
    "description": "Every Competition Creation Request you have submitted.",
    "newRequest": "Apply to host a new competition",
    "loading": "Loading…",
    "loadError": "Could not load your requests.",
    "empty": "You have not submitted any hosting request yet.",
    "columns": {
      "proposedName": "Proposed competition name",
      "status": "Status",
      "submittedAt": "Submitted at"
    }
  },
  "form": {
    "title": "Apply to host a new competition",
    "description": "A platform administrator reviews this. Once approved, the system automatically creates the competition and grants you its admin role — no further request is needed.",
    "proposedName": "Proposed competition name",
    "proposedSlug": "Proposed URL slug",
    "proposedSlugHint": "Lowercase letters, numbers and hyphens only, e.g. my-competition-2026.",
    "organization": "Organizer / organization",
    "contactPerson": "Contact person",
    "contactEmail": "Contact email",
    "description": "Purpose & description",
    "timezone": "Timezone",
    "expectedStartAt": "Expected start",
    "expectedEndAt": "Expected end",
    "expectedParticipants": "Expected participants",
    "judgingRequired": "Judging required",
    "twoRoundRequired": "Two-round competition",
    "studentMinorData": "Involves student / minor data",
    "notes": "Notes",
    "submit": "Submit request",
    "submitting": "Submitting…",
    "error": "Submission failed — check the fields and try again.",
    "cancel": "Cancel"
  },
  "detail": {
    "loading": "Loading…",
    "loadError": "Could not load this request.",
    "backToList": "← Back to my requests",
    "applicant": "Applicant details",
    "fields": {
      "proposedName": "Proposed competition name",
      "proposedSlug": "Proposed URL slug",
      "organization": "Organizer / organization",
      "contactPerson": "Contact person",
      "contactEmail": "Contact email",
      "description": "Purpose & description",
      "timezone": "Timezone",
      "expectedStartAt": "Expected start",
      "expectedEndAt": "Expected end",
      "expectedParticipants": "Expected participants",
      "judgingRequired": "Judging required",
      "twoRoundRequired": "Two-round competition",
      "studentMinorData": "Involves student / minor data",
      "notes": "Notes",
      "submittedAt": "Submitted at",
      "reviewedAt": "Reviewed at"
    },
    "yes": "Yes",
    "no": "No",
    "none": "None",
    "reviewReason": {
      "changesRequested": "The platform administrator requested changes:",
      "rejected": "The platform administrator rejected this request. Reason:",
      "approved": "Review note:"
    },
    "cancel": "Cancel request",
    "cancelConfirmTitle": "Cancel hosting request",
    "cancelConfirmImpact": "Cancelling ends the review process. You would need to submit a new request to host this competition.",
    "cancelSuccess": "The request was cancelled.",
    "reapply": "Submit a new request",
    "approvedBanner": "This request was approved. The competition has been created and you are its admin.",
    "goToCompetition": "Go to the admin workspace →"
  }
}
